/*
	This is used for client tags, matter tags, matter types, office/branch, document types, document statuses
*/

import API from "../utilities/LocalApiProxy";
import { isRateLimitError } from "./errorActions";
import { TAG_LIST_ACTION_MAP as tagListActionMap } from "./types";

//prefix: eg "/client/tags"
export function makeTagActions(prefix) {
	return {
		fetchTags: getTags(prefix),
		deactivateTags: deactivateTags(prefix),
		activateTags: activateTags(prefix),
		deleteTags: deleteTags(prefix),
		updateTags: updateTags(prefix),
		createTags: createTags(prefix),
	};
}

export function getTags(prefix) {
	return () => {
		return function (dispatch) {
			dispatch({
				type: tagListActionMap[prefix] + "_REQUEST",
			});
			API.get(prefix, {})
				.then((result) => {
					dispatch({
						type: tagListActionMap[prefix] + "_SUCCESS",
						payload: {
							tags: result.mysql,
							endpoint: prefix,
						},
					});
				})
				.catch((err) => {
					dispatch({
						type: tagListActionMap[prefix] + "_FAILURE",
						payload: {
							endpoint: prefix,
							rateLimited: isRateLimitError(err),
						},
					});
					console.log(err);
				});
		};
	};
}
export function deactivateTags(prefix) {
	return (tagIds) => {
		return function (dispatch) {
			API.put(prefix + "/deactivate", {
				body: { tagIds: tagIds },
			})
				.then(() => {
					getTags(prefix)()(dispatch);
				})
				.catch((err) => console.log(err));
		};
	};
}
export function activateTags(prefix) {
	return (tagIds) => {
		return function (dispatch) {
			API.put(prefix + "/activate", {
				body: { tagIds: tagIds },
			})
				.then(() => {
					getTags(prefix)()(dispatch);
				})
				.catch((err) => console.log(err));
		};
	};
}
export function deleteTags(prefix) {
	return (tagIds) => {
		return function (dispatch) {
			API.put(prefix + "/delete", {
				body: { tagIds: tagIds },
			})
				.then(() => {
					getTags(prefix)()(dispatch);
				})
				.catch((err) => console.log(err));
		};
	};
}
export function updateTags(prefix) {
	return (tags) => {
		return function (dispatch) {
			API.put(prefix, {
				body: { tags },
			})
				.then(() => {
					getTags(prefix)()(dispatch);
				})
				.catch((err) => console.log(err));
		};
	};
}
export function createTags(prefix) {
	return (newTags) => {
		return function (dispatch) {
			API.post(prefix, {
				body: { newTags },
			})
				.then(() => {
					getTags(prefix)()(dispatch);
				})
				.catch((err) => console.log(err));
		};
	};
}
